export const SkillData=
    [
        {
          name: 'Typescript',
          level: 80,
          color: '#404040',
        },
        {
          name: 'NodeJs',
          level: 70,
          color: '#404040',
        },
        {
          name: 'PHP',
          level: 90,
          color: '#404040',
        },
        {
          name: 'Python',
          level: 60,
          color: '#404040',
        },
        {
          name: 'ReactJS',
          level: 80,
          color: '#404040',
        },
        {
          name: 'Java',
          level: 65,
          color: '#404040',
        },
        {
          name: 'HTML/CSS',
          level: 75,
          color: '#404040',
        },
        {
          name: 'NOSQL',
          level: 60,
          color: '#404040',
        },
        {
            name: 'Kubernetes',
            level: 60,
            color: '#404040',
          },
        {
          name: 'Data Structures',
          level: 70,
          color: '#404040',
        },
        {
          name: 'JavaScript',
          level: 55,
          color: '#404040',
        },
        {
          name: 'SQL',
          level: 65,
          color: '#404040',
        }
    
      ]
